import { searchTermFromParam, type AdminActivityLogSearch } from './activityLogSearch'
import { isSearchDate, type PresetKey } from './activityRange'

/** Activity Search's own URL contract. It defaults to today: the API allows
 *  one day (ClickUp 14zf25zmrmz), so there is no week to look back over. */
export const ACTIVITY_SEARCH_DEFAULT_PRESET: PresetKey = 'today'

export interface AdminActivitySearchSearch {
  q?: string
  preset?: PresetKey
  from?: string
  to?: string
}

// No last7d: it is past the range cap, so a bookmark carrying it falls back to
// the default instead of sending a range the API would 400.
const PRESETS: readonly PresetKey[] = ['today', 'last24h', 'custom']

export function validateActivitySearchSearch(search: Record<string, unknown>): AdminActivitySearchSearch {
  const result: AdminActivitySearchSearch = {}
  const q = searchTermFromParam(search.q)
  if (q) result.q = q
  if (PRESETS.includes(search.preset as PresetKey)) result.preset = search.preset as PresetKey
  if (isSearchDate(search.from)) result.from = search.from
  if (isSearchDate(search.to)) result.to = search.to
  return result
}

/** Where a result row sends the admin: that doer's Activity Log, filtered to
 *  the same term over the same window. A relative preset is re-evaluated when
 *  the log opens, as any Activity Log link is. */
export function activityLogLinkSearch(doerId: string, s: AdminActivitySearchSearch): AdminActivityLogSearch {
  const preset = s.preset ?? ACTIVITY_SEARCH_DEFAULT_PRESET
  return {
    doerId,
    q: s.q,
    preset,
    ...(preset === 'custom' ? { from: s.from, to: s.to } : {}),
  }
}
